module.exports = __webpack_public_path__ + "static/media/chicken.7e7b66ad.png";